import utilPb from "@/proto/asset/util_pb";
import { ENDPOINT_VNF } from "@/env";

//export const API_URL = window.location.origin + "/api/v1/network-finder";
export const API_URL = ENDPOINT_VNF;

export const responseWrapper = <T>(
  resolve: (res: T) => void,
  reject: (err: string) => void,
) => {
  return (
    error: { code: number; message: string } | null,
    responseMessage: { toObject(): T } | null,
  ) => {
    if (error !== null) {
      reject(`Request failed: [Code ${error.code}] ${error.message}`);
    } else if (responseMessage === null) {
      reject(`Request failed: [Code -1] Response is null`);
    } else {
      resolve(responseMessage.toObject());
    }
  };
};

export type Pagination = {
  offset: number;
  limit: number;
};

export const createRequestPagination = (pagination: Pagination) => {
  const rp = new utilPb.RequestPagination();
  rp.setOffset(pagination.offset);
  rp.setLimit(pagination.limit);
  return rp;
};
